import { BoxStyleProps } from "@twilio-paste/core/box";

/*
 * position + layout ficam aqui (Emotion). Os offsets/alinhamento (bottom/left/right/align-items)
 * moveram para webchat-position.css (via data-test="webchat-root"), para serem configuráveis pelo
 * brand-config e sobrescrevíveis no @media do mobile. Default no CSS = bottom-right / 20 / 19.
 */
export const outerContainerStyles: BoxStyleProps = {
    position: "fixed",
    display: "flex",
    flexDirection: "column"
};

export const innerContainerStyles: BoxStyleProps = {
    boxShadow: "shadow",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "380px",
    height: "700px",
    // 120px = bottom 19px + launcher 64px (fica ABAIXO da janela) + marginBottom ~12px + respiro
    // no topo. Com só 40px, janela+launcher passavam de 100vh em telas baixas e o topo cortava.
    maxHeight: "calc(100vh - 120px)",
    marginBottom: "space40",
    backgroundColor: "colorBackgroundBody"
};
